<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import jquery from 'jquery'

  export default {
    name: 'App',

    updated() {
      // нужно для того чтобы в инпутах с типом number вращение колеса прокрутки мыши не меняло значения введенного числа
      jquery(function () {
        jquery(':input[type=number]').on('mousewheel', function (e) {
          jquery(this).blur()
        })
      })
    }
  }
</script>

<style>
  #app {
    height: 100%;
  }
</style>

<style src="./css/style.css"></style>
<style src="./css/adaptive.css"></style>
<style src="./font-awesome/css/font-awesome.min.css"></style>
<style src="./css/style_dev.css"></style>
